package br.com.vvrefeicoes.portal.core.di

import androidx.compose.runtime.staticCompositionLocalOf
import br.com.vvrefeicoes.portal.core.network.apiBaseUrl
import br.com.vvrefeicoes.portal.core.network.createHttpClient
import br.com.vvrefeicoes.portal.core.storage.createKeyValueStorage
import br.com.vvrefeicoes.portal.core.util.DateTimeProvider
import br.com.vvrefeicoes.portal.core.util.SystemDateTimeProvider
import br.com.vvrefeicoes.portal.data.repository.RemoteAnnouncementRepository
import br.com.vvrefeicoes.portal.data.repository.RemoteAuditRepository
import br.com.vvrefeicoes.portal.data.repository.RemoteAuthRepository
import br.com.vvrefeicoes.portal.data.repository.RemoteCepRepository
import br.com.vvrefeicoes.portal.data.repository.RemoteCompanyRepository
import br.com.vvrefeicoes.portal.data.repository.RemoteComplaintsDashboardRepository
import br.com.vvrefeicoes.portal.data.repository.RemoteConsolidatedDetailedRepository
import br.com.vvrefeicoes.portal.data.repository.RemoteConsolidatedRepository
import br.com.vvrefeicoes.portal.data.repository.RemoteCostsRepository
import br.com.vvrefeicoes.portal.data.repository.RemoteCustomerComplaintRepository
import br.com.vvrefeicoes.portal.data.repository.RemoteCustomerSatisfactionRepository
import br.com.vvrefeicoes.portal.data.repository.RemoteEntityFinancialsRepository
import br.com.vvrefeicoes.portal.data.repository.RemoteFoodPassRepository
import br.com.vvrefeicoes.portal.data.repository.RemoteFormsRepository
import br.com.vvrefeicoes.portal.data.repository.RemoteGuideRepository
import br.com.vvrefeicoes.portal.data.repository.RemoteHomeRepository
import br.com.vvrefeicoes.portal.data.repository.RemoteJuridicoCreditoRepository
import br.com.vvrefeicoes.portal.data.repository.RemoteJuridicoEmpresaRepository
import br.com.vvrefeicoes.portal.data.repository.RemoteJuridicoProcessoRepository
import br.com.vvrefeicoes.portal.data.repository.RemoteNotificationRepository
import br.com.vvrefeicoes.portal.data.repository.RemoteOperationalEntryRepository
import br.com.vvrefeicoes.portal.data.repository.RemoteOrgChartRepository
import br.com.vvrefeicoes.portal.data.repository.RemoteOverviewRepository
import br.com.vvrefeicoes.portal.data.repository.RemotePeopleRepository
import br.com.vvrefeicoes.portal.data.repository.RemotePurchasesExtraOrderRepository
import br.com.vvrefeicoes.portal.data.repository.RemotePurchasesRepository
import br.com.vvrefeicoes.portal.data.repository.RemoteRhDashboardRepository
import br.com.vvrefeicoes.portal.data.repository.RemoteRhSheetRepository
import br.com.vvrefeicoes.portal.data.repository.RemoteRmpRepository
import br.com.vvrefeicoes.portal.data.repository.RemoteRmpRequestRepository
import br.com.vvrefeicoes.portal.data.repository.RemoteSatisfactionDashboardRepository
import br.com.vvrefeicoes.portal.data.repository.RemoteSatisfactionReportsRepository
import br.com.vvrefeicoes.portal.data.repository.RemoteSocialConnectionRepository
import br.com.vvrefeicoes.portal.data.repository.RemoteSupplierRepository
import br.com.vvrefeicoes.portal.data.repository.RemoteSystemRepository
import br.com.vvrefeicoes.portal.data.repository.RemoteUserDocumentRepository
import br.com.vvrefeicoes.portal.data.repository.RemoteUserRepository
import br.com.vvrefeicoes.portal.domain.repository.AnnouncementRepository
import br.com.vvrefeicoes.portal.domain.repository.AuditRepository
import br.com.vvrefeicoes.portal.domain.repository.AuthRepository
import br.com.vvrefeicoes.portal.domain.repository.CepRepository
import br.com.vvrefeicoes.portal.domain.repository.CompanyRepository
import br.com.vvrefeicoes.portal.domain.repository.ComplaintsDashboardRepository
import br.com.vvrefeicoes.portal.domain.repository.ConsolidatedDetailedRepository
import br.com.vvrefeicoes.portal.domain.repository.ConsolidatedRepository
import br.com.vvrefeicoes.portal.domain.repository.CostsRepository
import br.com.vvrefeicoes.portal.domain.repository.CustomerComplaintRepository
import br.com.vvrefeicoes.portal.domain.repository.CustomerSatisfactionRepository
import br.com.vvrefeicoes.portal.domain.repository.DirectorFinancialsRepository
import br.com.vvrefeicoes.portal.domain.repository.FormsRepository
import br.com.vvrefeicoes.portal.domain.repository.GuideRepository
import br.com.vvrefeicoes.portal.domain.repository.HomeRepository
import br.com.vvrefeicoes.portal.domain.repository.JuridicoCreditoRepository
import br.com.vvrefeicoes.portal.domain.repository.JuridicoEmpresaRepository
import br.com.vvrefeicoes.portal.domain.repository.JuridicoProcessoRepository
import br.com.vvrefeicoes.portal.domain.repository.ManagerFinancialsRepository
import br.com.vvrefeicoes.portal.domain.repository.NotificationRepository
import br.com.vvrefeicoes.portal.domain.repository.OperationalEntryRepository
import br.com.vvrefeicoes.portal.domain.repository.OrgChartRepository
import br.com.vvrefeicoes.portal.domain.repository.OverviewRepository
import br.com.vvrefeicoes.portal.domain.repository.PeopleRepository
import br.com.vvrefeicoes.portal.domain.repository.PurchasesExtraOrderRepository
import br.com.vvrefeicoes.portal.domain.repository.PurchasesRepository
import br.com.vvrefeicoes.portal.domain.repository.RhDashboardRepository
import br.com.vvrefeicoes.portal.domain.repository.RhSheetRepository
import br.com.vvrefeicoes.portal.domain.repository.RmpRepository
import br.com.vvrefeicoes.portal.domain.repository.RmpRequestRepository
import br.com.vvrefeicoes.portal.domain.repository.SatisfactionDashboardRepository
import br.com.vvrefeicoes.portal.domain.repository.SatisfactionReportsRepository
import br.com.vvrefeicoes.portal.domain.repository.SocialConnectionRepository
import br.com.vvrefeicoes.portal.domain.repository.SupplierRepository
import br.com.vvrefeicoes.portal.domain.repository.SystemRepository
import br.com.vvrefeicoes.portal.domain.repository.UnitFinancialsRepository
import br.com.vvrefeicoes.portal.domain.repository.UserRepository
import br.com.vvrefeicoes.portal.feature.notifications.NotificationSocket
import io.ktor.client.call.body
import io.ktor.client.request.get

class AppGraph {
    private val authHttpClient by lazy { createHttpClient() }
    private val httpClient by lazy {
        createHttpClient { failedToken ->
            val currentAuthorization =
                authRepository.session.value
                    ?.token
                    ?.let { "Bearer $it" }
            if (currentAuthorization != null && currentAuthorization != failedToken) {
                currentAuthorization.removePrefix("Bearer ")
            } else {
                authRepository.restoreSession()
                authRepository.session.value
                    ?.token
                    ?.takeIf { "Bearer $it" != failedToken }
            }
        }
    }

    val authRepository: AuthRepository by lazy { RemoteAuthRepository(authHttpClient, apiBaseUrl, createKeyValueStorage()) }

    val dateTimeProvider: DateTimeProvider = SystemDateTimeProvider()
    val formsRepository: FormsRepository by lazy {
        RemoteFormsRepository(httpClient, apiBaseUrl, authRepository)
    }

    val loadError: LoadErrorState = LoadErrorState()

    val orgChartRepository: OrgChartRepository by lazy { RemoteOrgChartRepository(httpClient, apiBaseUrl, authRepository) }

    val companyRepository: CompanyRepository by lazy { RemoteCompanyRepository(httpClient, apiBaseUrl, authRepository) }

    val juridicoEmpresaRepository: JuridicoEmpresaRepository by lazy {
        RemoteJuridicoEmpresaRepository(httpClient, apiBaseUrl, authRepository)
    }

    val juridicoCreditoRepository: JuridicoCreditoRepository by lazy {
        RemoteJuridicoCreditoRepository(httpClient, apiBaseUrl, authRepository)
    }

    val juridicoProcessoRepository: JuridicoProcessoRepository by lazy {
        RemoteJuridicoProcessoRepository(httpClient, apiBaseUrl, authRepository)
    }

    val foodPassRepository by lazy { RemoteFoodPassRepository(httpClient, apiBaseUrl, authRepository) }

    val cepRepository: CepRepository by lazy { RemoteCepRepository(httpClient) }

    val userRepository: UserRepository by lazy { RemoteUserRepository(httpClient, apiBaseUrl, authRepository) }

    val userDocumentRepository by lazy { RemoteUserDocumentRepository(httpClient, apiBaseUrl, authRepository) }

    val auditRepository: AuditRepository by lazy { RemoteAuditRepository(httpClient, apiBaseUrl, authRepository) }

    val operationalEntryRepository: OperationalEntryRepository by lazy { RemoteOperationalEntryRepository(httpClient, apiBaseUrl, authRepository) }

    val supplierRepository: SupplierRepository by lazy { RemoteSupplierRepository(httpClient, apiBaseUrl, authRepository) }

    val systemRepository: SystemRepository by lazy { RemoteSystemRepository(httpClient, apiBaseUrl, authRepository) }

    val socialConnectionRepository: SocialConnectionRepository by lazy {
        RemoteSocialConnectionRepository(httpClient, apiBaseUrl, authRepository)
    }

    val customerSatisfactionRepository: CustomerSatisfactionRepository by lazy {
        RemoteCustomerSatisfactionRepository(httpClient, orgChartRepository, authRepository, apiBaseUrl)
    }

    val customerComplaintRepository: CustomerComplaintRepository by lazy {
        RemoteCustomerComplaintRepository(httpClient, apiBaseUrl, authRepository)
    }

    val complaintsDashboardRepository: ComplaintsDashboardRepository by lazy {
        RemoteComplaintsDashboardRepository(httpClient, apiBaseUrl, authRepository)
    }

    val satisfactionDashboardRepository: SatisfactionDashboardRepository by lazy {
        RemoteSatisfactionDashboardRepository(httpClient, apiBaseUrl, authRepository)
    }

    val satisfactionReportsRepository: SatisfactionReportsRepository by lazy {
        RemoteSatisfactionReportsRepository(httpClient, authRepository, apiBaseUrl)
    }

    val overviewRepository: OverviewRepository by lazy { RemoteOverviewRepository(httpClient, apiBaseUrl, authRepository) }

    val managerFinancialsRepository: ManagerFinancialsRepository by lazy {
        RemoteEntityFinancialsRepository(httpClient, apiBaseUrl, authRepository, "/operational/managers")
    }

    val directorFinancialsRepository: DirectorFinancialsRepository by lazy {
        RemoteEntityFinancialsRepository(httpClient, apiBaseUrl, authRepository, "/operational/directors")
    }

    val unitFinancialsRepository: UnitFinancialsRepository by lazy {
        RemoteEntityFinancialsRepository(httpClient, apiBaseUrl, authRepository, "/operational/units")
    }

    val costsRepository: CostsRepository by lazy { RemoteCostsRepository(httpClient, apiBaseUrl, authRepository) }

    val consolidatedRepository: ConsolidatedRepository by lazy { RemoteConsolidatedRepository(httpClient, apiBaseUrl, authRepository) }

    val consolidatedDetailedRepository: ConsolidatedDetailedRepository by lazy { RemoteConsolidatedDetailedRepository(httpClient, apiBaseUrl, authRepository) }

    val peopleRepository: PeopleRepository by lazy { RemotePeopleRepository(httpClient, apiBaseUrl, authRepository) }

    val purchasesRepository: PurchasesRepository by lazy { RemotePurchasesRepository(httpClient, apiBaseUrl, authRepository) }

    val purchasesExtraOrderRepository: PurchasesExtraOrderRepository by lazy {
        RemotePurchasesExtraOrderRepository(httpClient, apiBaseUrl, authRepository)
    }

    val rhSheetRepository: RhSheetRepository by lazy { RemoteRhSheetRepository(httpClient, apiBaseUrl, authRepository) }

    val rhDashboardRepository: RhDashboardRepository by lazy { RemoteRhDashboardRepository(httpClient, apiBaseUrl, authRepository) }

    val rmpRepository: RmpRepository by lazy { RemoteRmpRepository(httpClient, apiBaseUrl, authRepository) }

    val rmpRequestRepository: RmpRequestRepository by lazy { RemoteRmpRequestRepository(httpClient, apiBaseUrl, authRepository) }

    val notificationRepository: NotificationRepository by lazy {
        RemoteNotificationRepository(httpClient, apiBaseUrl, authRepository)
    }

    val announcementRepository: AnnouncementRepository by lazy {
        RemoteAnnouncementRepository(httpClient, apiBaseUrl, authRepository)
    }

    val guideRepository: GuideRepository by lazy {
        RemoteGuideRepository(httpClient, apiBaseUrl, authRepository)
    }

    val homeRepository: HomeRepository by lazy {
        RemoteHomeRepository(httpClient, apiBaseUrl, authRepository)
    }

    val notificationSocket: NotificationSocket by lazy {
        NotificationSocket(httpClient, apiBaseUrl, authRepository)
    }

    /** Baixa uma imagem (ex.: do modal de notificação) sem exigir autenticação. */
    suspend fun loadImageBytes(url: String): ByteArray? = runCatching { httpClient.get(url).body<ByteArray>() }.getOrNull()

    /** Converte um caminho relativo da API (ex.: /announcements/images/{id}) em URL absoluta. */
    fun absoluteUrl(path: String?): String? {
        if (path.isNullOrBlank()) return null
        if (path.startsWith("http://") || path.startsWith("https://")) return path
        return apiBaseUrl.trimEnd('/') + (if (path.startsWith("/")) path else "/$path")
    }
}

val LocalAppGraph =
    staticCompositionLocalOf<AppGraph> {
        error("AppGraph não foi fornecido. Envolva a UI com CompositionLocalProvider(LocalAppGraph provides ...).")
    }
